/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_SourceInputs */

const en_road_dude_clips_source = /** @type {(inputs: Road_Dude_Clips_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the examples on Media.io`)
};

const zh_road_dude_clips_source = /** @type {(inputs: Road_Dude_Clips_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Media.io 查看案例`)
};

/**
* | output |
* | --- |
* | "See the examples on Media.io" |
*
* @param {Road_Dude_Clips_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_source = /** @type {((inputs?: Road_Dude_Clips_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_source(inputs)
	return zh_road_dude_clips_source(inputs)
});
export { road_dude_clips_source as "road_dude.clips.source" }